module.exports = __webpack_public_path__ + "static/media/negative-exponent-custom.733c4067.svg";